import { render, staticRenderFns } from "./df-page-special.vue?vue&type=template&id=014871bb"
import script from "./df-page-special.ts?vue&type=script&lang=js&external"
export * from "./df-page-special.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports